import { IconButton, Tooltip } from '@mui/material';
import { size } from 'lodash-es';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { MdInfo } from 'react-icons/md';

function ClickableTooltip(props) {
  const { icon = null, message, ...rest } = props;

  const [open, setOpen] = useState(false);

  const messageLength = size(message);
  let timeout = 2000;
  if (messageLength > 50) {
    timeout = Math.min(5000, (messageLength - 50) * 50 + 2000);
  }

  const handleClick = () => {
    setOpen(true);
    setTimeout(() => setOpen(false), timeout);
  };

  return (
    <Tooltip
      {...rest}
      open={open}
      title={message}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      // PopperProps={{
      //   disablePortal: true,
      // }}
    >
      <IconButton
        size="small"
        onClick={handleClick}
        disableRipple
        disableFocusRipple
        sx={{ padding: 0 }}
      >
        {icon || <MdInfo />}
      </IconButton>
    </Tooltip>
  );
}

ClickableTooltip.propTypes = {
  message: PropTypes.string.isRequired,
  icon: PropTypes.node,
};

export default ClickableTooltip;
